// extracted by mini-css-extract-plugin
export default {"thankYou":"ThankYou_thankYou__7hJeB","thankYouStandFirst":"ThankYou_thankYouStandFirst__arCR1","thankYouLink":"ThankYou_thankYouLink__TWmVh"};